import { SelectedPlace } from "@/interfaces/searchBlock";
import { PlaceCoordinates } from "./getPlaceCoordinates";

const StartCitiesToUpdate = [
  {
    description: "Vienne,",
    coordinates: {
      computedLatitude: 45.502429,
      computedLongitude: 4.854938,
    },
  },
];

export const computeRoundTripStartCoordinates = (
  selectedPlace: SelectedPlace,
  startCoordinates: PlaceCoordinates
): PlaceCoordinates => {
  const isCityToUpdate = StartCitiesToUpdate.find((city) =>
    selectedPlace.description.startsWith(city.description)
  );

  return isCityToUpdate ? isCityToUpdate.coordinates : startCoordinates;
};
